<template>
	<div>
		<div class="d-none">
			<div ref="pdf_content">
				<table cellspacing="0" cellpadding="0"
					style="font-family:Arial; width:525.75pt; margin-right:auto; margin-left:auto; border:0.75pt solid #ffffff; border-collapse:collapse;">
					<tbody>
						<tr>
							<td width="80%"
								style="border-right:1.5pt solid #2c246d; padding:0.75pt 8.25pt 0.75pt 0.38pt; vertical-align:middle;">
								<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; font-size:10pt; line-height: 13pt;">
									<strong style="font-size:13.5pt;">FINTOS CAPITAL SDN. BHD.</strong>
									<span>&nbsp;198401014613 (127169-T)</span><br>
									<strong><em><span>(Formerly known as Invinity Credit Sdn. Bhd.)</span></em></strong><br>
									<span>Puchong Financial Corporate Centre, Lot No. 11F-2, 11th Floor,</span><br>
									<span>Tower 4 @ PFCC, Jalan Puteri 1/2, Bandar Puteri, 47160 Puchong, Selangor.</span><br>
									<strong><span style="color:#2dbe7a;">Tel (O)</span></strong>
									<span style="color:#2dbe7a;">&nbsp;</span>
									<span>03-8080 9777 (Press No.4) |&nbsp;</span>
									<strong><span style="color:#2dbe7a;">(M)</span></strong>
									<strong><span> </span></strong>
									<span>+6012-347 9128&nbsp;</span><br><span>General Email: enquiryfintoscapital@fintos.com.my</span>
								</p>
							</td>
							<td style="vertical-align:middle;">
								<p style="margin-top:0pt; margin-bottom:0pt; text-align:right; line-height:150%; font-size:10pt;"><img
										:src="base64Logo" width="192" height="75" alt=""></p>
							</td>
						</tr>
					</tbody>
				</table>
				<div id="doc_discharge_letter">
					<table>
						<tbody>
							<tr>
								<td style="color:#ff0000; width: 50px;"><strong>Ref</strong></td>
								<td style="color:#ff0000; width: 5px;"><strong>:</strong></td>
								<td style="color:#ff0000;"><strong>{{ _gHlp.getValue(activeCase, 'case_no', '-') }}</strong></td>
							</tr>
							<tr>
								<td>Date</td>
								<td>:</td>
								<td>{{ _gHlp.getCurrentDateTime(false) | dateTimeDynamicFormat('D MMMM YYYY') }}</td>
							</tr>
						</tbody>
					</table>
					<div class="mb-3">
						<strong> {{ _gHlp.getValue(activeCustomer, 'name', '-') }}</strong><br/>
						<strong>(NRIC NO. : {{ _gHlp.getValue(activeCustomer, 'nric', '') | formatNRIC }})</strong><br><br>
						<p>{{ _gHlp.getValue(activeCustomer, 'locations.nric.address_1', '') }}</p>
					</div>
					<div class="mb-2">
						<p>Dear Sir/Madam,</p>
					</div>
					<table>
						<tbody>
							<tr>
								<td colspan="3"><strong><u>RE: LETTER OF DISCHARGE AND CONFIRMATION</u></strong></td>
							</tr>
							<tr>
								<td style="width: 110px;"><strong>BORROWER</strong></td>
								<td>:</td>
								<td><strong>{{ _gHlp.getValue(activeCustomer, 'name', '-') }}</strong></td>
							</tr>
							<tr>
								<td><strong>ACCOUNT NO.</strong></td>
								<td>:</td>
								<td><strong>{{ account_no }}</strong></td>
							</tr>
						</tbody>
					</table>
					<div align="center">
						<hr size="2" align="center" style="width:100%;">
					</div>
					<p style="margin-top:0pt; margin-bottom:0pt; line-height:13pt; font-size:10pt;">
						The above matter refers.<br><br>
						We hereby confirm that the full loan sum due and payable to our company
						for the forementioned Account has been fully settled and paid off to our company which our company
						acknowledge receipt of such sum from your goodselves.<br><br>
						Consequentially, you have fulfilled your obligation pursuant to the Loan
						Agreement dated
						<strong>{{ _gHlp.getValue(activeCase, 'loan_approved_date', '-') | dateTimeDynamicFormat('D MMMM YYYY')
							}}</strong>
						and you shall be discharged from the
						Loan Agreement as the Borrower.<br><br>We thank you
						for your relentless support toward our company and we look forward to serving you in the future.
						Please do not hesitate to contact our customer support should you require any further
						assistance.<br><br>
						Thank you.<br><br>
						Redemption Unit,<br>
						Credit Support &amp; Administration<br>
						For and behalf of<br>
						<strong>FINTOS CAPITAL SDN. BHD.</strong><br>
						<strong>(Formerly known as Invinity Credit Sdn. Bhd.)</strong><br>
						<strong>(Company No.: 127169-T)</strong>
					</p>

					<p style="margin-top:50px; margin-bottom:0pt; text-align:center; line-height:150%; font-size:10pt;">
						<em><span>This is computer generated letter. No signature is
								required.</span></em>
					</p>
				</div>
			</div>
		</div>
		<div class="preview">
			<modal :show.sync="is_visible" :hide-footer="true" bodyClasses="preview-modal">
				<div class="text-center">
					<iframe v-if="!_gHlp.isEmpty(pdfUrl)" :src="pdfUrl" class="iframe-preview w-100"></iframe>
				</div>
			</modal>
		</div>
	</div>
</template>
<style>
#doc_discharge_letter{
	width: 100%;
	page-break-inside: auto;
	font-size: 10pt;
	margin-top: 25px;
}
#doc_discharge_letter table{
	border: none;
	border-collapse: collapse;
	margin-bottom: 20px;
}
#doc_discharge_letter table td,
#doc_discharge_letter table th{
	padding: 1px 5px 1px 0px;
	font-size: 10pt;
}

</style>
<script>
import { mapState, mapActions } from 'pinia';
import { useCustomerStore } from '@/stores/customerStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';

export default {
	data() {
		return {
			// Add your component data here
			pdfUrl: null,
			is_visible: false,
			base64Logo: ''
		};
	},
	async created() {
		this.base64Logo = await _gFile.getContentUrl('https://fintos-public.s3.ap-southeast-1.amazonaws.com/fintos_capital.jpg')
		// Add your created lifecycle hook here
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer', 'activeLoanEC']),
		...mapState(useLoanCaseStore, ['activeCase']),
		account_no() {
			let alt = _gHlp.formatDate(_gHlp.getValue(this.activeCase, 'created_at', ''), 'Ymd') + '' + _gHlp.getValue(this.activeCase, 'case_id', '');
			return _gHlp.getValue(this.activeCase, 'account_no', alt);
		},
	},
	watch: {
		'pdfUrl': {
			handler(newValue, oldValue) {
				if (newValue) {
					console.log(newValue);
				}
			},
			immediate: true
		},
	},
	methods: {
		async show() {
			await this.initPDF();
		},
		async initPDF() {
			// Capture the rendered HTML of the component (inside the `content` div)
			const content = this.$refs.pdf_content;
			this.pdfUrl = await _gFile.htmlToPdfUrl(content, 'Discharge_Letter_' + _gHlp.getValue(this.activeCase, 'case_id', '') + '_' + _gHlp.getCurrentDateTime(false) + '.pdf');
			this.is_visible = true;

		}
	},
	// Add your computed properties here
};
</script>
